export class DataLayerService {
    static readonly CTA_CSS_SELECTOR: string = 'a[href]:not([href^="#"]):not([data-layer-click-exclude])';
    private static readonly NON_CONTENT_FILE_PATTERN: RegExp = /\.[a-z0-9]+$/i;

    public static registerCtaEventListeners(
        onActivate: (anchor: HTMLAnchorElement, event: Event) => void
    ): () => void {
        if (typeof document === 'undefined') {
            return () => undefined;
        }

        const anchors = Array.from(
            document.querySelectorAll<HTMLAnchorElement>(DataLayerService.CTA_CSS_SELECTOR)
        );

        anchors?.forEach(anchor => {
            if (!this.isEqualToCurrentUrlPath(anchor?.href)) {
                anchor.addEventListener('click',  event => onActivate(anchor, event));
            }
        })
        return () => undefined;
    }

    public static isEqualToCurrentUrlPath(href: string): boolean {
        if (!href) {
            return false;
        }

        try {
            const currentUrl = new URL(window.location.href);
            const linkUrl = new URL(href, currentUrl);

            return (
                linkUrl.origin === currentUrl.origin &&
                this.normalizePathname(linkUrl.pathname) === this.normalizePathname(currentUrl.pathname)
            );
        } catch {
            return false;
        }
    }

    public static isInternalContentLink(href: string): boolean {
        if (!href) {
            return false;
        }
        try {
            const currentUrl = new URL(window.location.href);
            const linkUrl = new URL(href, currentUrl);
            if (linkUrl.origin !== currentUrl.origin) {
                return false;
            }
            const hasFileExtension = this.NON_CONTENT_FILE_PATTERN.test(linkUrl.pathname);
            return !hasFileExtension || linkUrl.pathname.endsWith('.html');
        } catch {
            return false;
        }
    }

    private static normalizePathname(pathname: string): string {
        if (!pathname) {
            return '/';
        }

        if (pathname.length > 1 && pathname.endsWith('/')) {
            return pathname.slice(0, -1);
        }

        return pathname;
    }
}
